import React, { useState } from 'react';
import { useQueryClient, useMutation, useQuery } from 'react-query';
import { 
    UserInfo,
    userLogin
} from '../queries/query';
import { encryptData } from '../helpers/CryptoFun';

export const AuthContext = React.createContext();

export default function AuthContextProvider({ children }) {
    const [auth, setAuth] = useState(false);
    const queryClient = useQueryClient();

    const [errorAuth, setErrorAuth] = useState(null)
    const [successAuth, setSuccessAuth] = useState(null)

    const emptyErrorAuth = () => setErrorAuth(null)
    const emptySuccessAuth = () => setSuccessAuth(null)
    
    const signOut = () => {
        localStorage.removeItem('gsmart-ip-user')
        setAuth(false)
    }

    // Login
    const { 
        mutate: loginMutation, 
        isLoading: isLoadingLogin 
    } = useMutation(async data => {
        const res = await userLogin({"email": data?.email, "password": data?.password});
        if (res.status === true) {
            const user = {
                'id': res?.user,
                'email': data?.email,
                'password': data?.password,
                'adminId': res?.admin,
                'adminPassword': res?.word,
            }
            localStorage.setItem('gsmart-ip-user', encryptData(user))
        }
    },{
        onSuccess: () => {
            setErrorAuth(null)
            queryClient.invalidateQueries('authentication');
        },
        onError: (error) => {
            setErrorAuth({login: "login_error"})
        },
        throwOnError: true,
    });

    // Get Profile info
    const {
        data: profile,
        isLoading: profileLoading,
        isFetching: profileFetching
    } = useQuery('authentication', UserInfo, {
        retry: 0,
        refetchOnWindowFocus: false,
        onSuccess: () => {
            setAuth(true)
            setErrorAuth(null)
            queryClient.invalidateQueries('subCompanies');
        },
        onError: (error) => {
            signOut()
            setErrorAuth({subCompanies: "subCompanies_error"})
        },
        throwOnError: true,
    });
        
    return (
        <AuthContext.Provider
            value={{
                loginMutation,
                isLoadingLogin,

                profile,
                profileLoading,
                profileFetching,
                isAuth: auth, //(!logout && profile?.id) ? true : false,

                errorAuth,
                successAuth,
                emptyErrorAuth,
                emptySuccessAuth,

                signOut
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}
